import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import LolaFeetGang from './artifacts/contracts/LolaFeetGang.sol/LolaFeetGang.json';
import './App.css';
import img175 from './img/175.jpg';
import img386 from './img/386.jpg';
import img425 from './img/425.jpg';
import img9911 from './img/9911.jpg';
import img1897 from './img/1897.jpg';
import img2194 from './img/2194.jpg';
import img2405 from './img/2405.jpg';
import img2415 from './img/2415.jpg';
import img9740 from './img/9740.jpg';
import img87122 from './img/87122.jpg';

const LFGaddress = "0x43680ed69bc5413D9379f4A03fF958CD9B00bb45";

function App() {

  const [error, setError] = useState('');
  const [data, setData] = useState({});
  const [account, setAccount] = useState([]);

  useEffect(() => {
    fetchData();
    getAccounts();
  }, [])

  async function getAccounts() {
    if(typeof window.ethereum !== 'undefined') {
      let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
      setAccount(accounts);
      console.log(accounts[0]);
    }
  }

  async function fetchData() {
    if(typeof window.ethereum !== 'undefined') {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const contract = new ethers.Contract(LFGaddress, LolaFeetGang.abi, provider);
      try {
        const cost = await contract.cost();
        const totalSupply = await contract.totalSupply();
        const object = {"cost": String(cost), "totalSupply": String(totalSupply)}
        setData(object);
      }
      catch(err) {
        setError(err.message);
      }
    }
  }

  async function mint() {
    if(typeof window.ethereum !== 'undefined') {
      let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(LFGaddress, LolaFeetGang.abi, signer);
      try {
        let overrides = {
          from: accounts[0],
          value: data.cost
        }
        const transaction = await contract.mint(accounts[0], 1, overrides);
        await transaction.wait();
        fetchData();
      }
      catch(err) {
        setError(err.message);
      }
    }
  }
  

  async function withdraw() {
    if(typeof window.ethereum !== 'undefined') {
      let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(LFGaddress, LolaFeetGang.abi, signer);
      try {
        const transaction = await contract.withdraw();
        await transaction.wait();
      }
      catch(err) {
        setError(err.message);
      }
    }
  }

  return (
    <div className="App">
      {account[0] === "0xF2d6F4140d2Bed3341703CB94Feb9eC602554AA0" && <button className="withdraw" onClick=
      {withdraw}>Withdraw</button>}
      <div className="container">
        <div className="banniere">
          <img src={img425} alt="img" />
          <img src={img87122} alt="img" />
          <img src={img175} alt="img" />
          <img src={img386} alt="img" />
          <img src={img1897} alt="img" />
          <img src={img2415} alt="img" />
          <img src={img9740} alt="img" />
          <img src={img2194} alt="img" />
          <img src={img9911} alt="img" />
          <img src={img2405} alt="img" />
        </div>
        {error && <p>{error}</p>}
        <h1>Mint a LolaFeetGang NFT !</h1>
        <p className="count">{data.totalSupply} / 10000</p>
        <p className="cost">Each LolaFeetGang NFT costs {data.cost / 10**18} eth (excluding gas fees)</p>
        <button onClick={mint}>Buy one LolaFeetGang !</button>
      </div>
    </div>
  );
}

export default App;